// extracted by mini-css-extract-plugin
export default {"statusIcon":"Table_statusIcon__-bv3L"};